export default __webpack_public_path__ + "static/media/session_expired.6ac2f1f5.svg";